module.exports = __webpack_public_path__ + "img/helper8.2caae4db.png";